/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { removeFromStorage } from '../../utils/webStorage';
import { useGetCurrentUserQuery } from '../../store/user/userApi';
import Navigation from './Navigation';
import ThemeToggle from '../../shared/theme-toggle';
import { useTheme } from '../../theme-context';
import Cookies from 'js-cookie';
import AiAgentsSidebar from '../../features/dashboard/settings/tabs/AiAgentsSidebar';
import { DOMAIN } from '../../config';

interface ISidebar {
    onClickShowModal: () => void;
    onClickOpenChat: (id?: string, action?: any) => void;
    isMobile?: boolean;
}

const Sidebar = ({
    onClickShowModal,
    onClickOpenChat,
    isMobile = false,
}: ISidebar) => {
    const navigate = useNavigate();
    const { theme } = useTheme();
    const [userInfoData, setUserInfoData] = useState<any>();
    const { data: userInfo } = useGetCurrentUserQuery();
    const [search, setSearch] = useState<string>();

    const handleLogout = () => {
        removeFromStorage('accessToken');
        removeFromStorage('refreshToken');
        removeFromStorage('roles');
        removeFromStorage('user');
        Cookies.remove('accessToken', {
            domain: String(DOMAIN).replace(/^https?:\/\//, '.'),
            path: '/',
        });
        Cookies.remove('refreshToken', {
            domain: String(DOMAIN).replace(/^https?:\/\//, '.'),
            path: '/',
        });
        Cookies.remove('roles', {
            domain: String(DOMAIN).replace(/^https?:\/\//, '.'),
            path: '/',
        });
        Cookies.remove('user');

        window.location.href = DOMAIN || '/';
        // window.location.reload();
        // (window as any).Intercom('shutdown');
        // navigate('/login');
    };

    const onChangePageSearch = (value: string) => {
        setSearch(value);
    };

    const isJsonObject = (jsonString: string) => {
        try {
            const o = JSON.parse(jsonString);
            if (o && typeof o === 'object') {
                return true;
            }
        } catch (e) {}
        return false;
    };

    const getCurrentUserData = async () => {
        const getUserLocal: any = localStorage.getItem('user') || null;
        const userFormat: any = isJsonObject(getUserLocal)
            ? JSON.parse(getUserLocal)
            : undefined;
        if (getUserLocal && !userFormat && !userFormat?.username) {
            setUserInfoData(getUserLocal);
        } else {
            setUserInfoData(userInfo?.username);
            // localStorage.setItem('user', userInfo?.username || '');
            localStorage.setItem('user', userInfo?.username || '');
        }
    };

    useEffect(() => {
        if (!userInfoData) {
            getCurrentUserData();
        }
    }, [userInfo]);

    const onClickSettings = () => {
        navigate('/settings');
    };

    return (
        <div
            className={`${
                isMobile
                    ? 'w-64 h-full flex flex-col bg-white dark:bg-[#2a2a2a] z-10'
                    : 'hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 border-r-1 border-r dark:border-borderColor-darkMode dark:bg-bgColor-darkMode z-10'
            }`}>
            <div className="flex flex-row items-center justify-between mb-6 mt-4 px-3 sm:px-4">
                <div className="flex flex-row items-center">
                    <img
                        className="w-10 h-10 sm:w-12 sm:h-12 bg-black dark:bg-white rounded-full mr-2"
                        src="/assets/profile/user-icon.svg"
                        alt="main photo"
                    />
                    <div className="text-left">
                        <div
                            title={userInfoData}
                            className="text-sm sm:text-base font-normal text-primary-light dark:text-primary-dark truncate max-w-[120px] overflow-hidden whitespace-nowrap">
                            {userInfoData}
                        </div>
                        <p className="text-xs sm:text-sm text-primary-light dark:text-primary-dark">
                            Administrator
                        </p>
                    </div>
                </div>
                <div className="flex flex-row items-center justify-end">
                    <div
                        className="cursor-pointer hover:opacity-80"
                        onClick={onClickSettings}>
                        <img
                            src={
                                theme === 'dark'
                                    ? '/assets/navigation-icons/sidebar/settings-icon-white.svg'
                                    : '/assets/navigation-icons/sidebar/settings-icon.svg'
                            }
                            className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2"
                        />
                    </div>
                    <div
                        className="cursor-pointer hover:opacity-80"
                        onClick={handleLogout}>
                        <img
                            src={
                                theme === 'dark'
                                    ? '/assets/navigation-icons/sidebar/logout-icon-white.svg'
                                    : '/assets/navigation-icons/sidebar/logout-icon.svg'
                            }
                            className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px]"
                        />
                    </div>
                </div>
            </div>

            <div className="border-b py-3 px-3 sm:px-4">
                <NavLink
                    className="flex flex-row items-center cursor-pointer hover:opacity-80 px-1 sm:px-2 mb-3"
                    to="/employee-updated-news">
                    <img
                        src={
                            theme === 'dark'
                                ? '/assets/navigation-icons/sidebar/new-question-white.svg'
                                : '/assets/navigation-icons/sidebar/new-question.svg'
                        }
                        className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3"
                    />
                    <p className="text-sm sm:text-base dark:text-primary-dark">
                        Employee news
                    </p>
                </NavLink>
                <NavLink
                    className="flex flex-row items-center cursor-pointer hover:opacity-80 px-1 sm:px-2 mb-3"
                    to="/ui-branding">
                    <img
                        src={
                            theme === 'dark'
                                ? '/assets/navigation-icons/sidebar/new-question-white.svg'
                                : '/assets/navigation-icons/sidebar/new-question.svg'
                        }
                        className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3"
                    />
                    <p className="text-sm sm:text-base dark:text-primary-dark">
                        Customize UI Branding
                    </p>
                </NavLink>
                <NavLink
                    className="flex flex-row items-center cursor-pointer hover:opacity-80 px-1 sm:px-2 mb-3"
                    to="/queries">
                    <img
                        src={
                            theme === 'dark'
                                ? '/assets/navigation-icons/sidebar/new-question-white.svg'
                                : '/assets/navigation-icons/sidebar/new-question.svg'
                        }
                        className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3"
                    />
                    <p className="text-sm sm:text-base dark:text-primary-dark">
                        Show Queries and Feedbacks
                    </p>
                </NavLink>
                <AiAgentsSidebar />
                <div
                    onClick={() => onClickOpenChat(undefined, undefined)}
                    className="flex flex-row items-center cursor-pointer hover:opacity-80 px-1 sm:px-2 mb-3">
                    <img
                        src={
                            theme === 'dark'
                                ? '/assets/navigation-icons/sidebar/new-question-white.svg'
                                : '/assets/navigation-icons/sidebar/new-question.svg'
                        }
                        className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3"
                    />
                    <p className="text-sm sm:text-base dark:text-primary-dark">
                        Ask Questions
                    </p>
                </div>
                <div
                    onClick={onClickShowModal}
                    className="flex flex-row !rounded-lg bg-[#FAFAFA] dark:bg-black items-center justify-between p-2 cursor-pointer hover:opacity-80">
                    <div className="flex flex-row items-center">
                        <img
                            src={
                                theme === 'dark'
                                    ? '/assets/navigation-icons/sidebar/search-icon-white.svg'
                                    : '/assets/navigation-icons/sidebar/search-icon.svg'
                            }
                            className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3"
                        />
                        <p className="text-sm sm:text-base text-primary-light">
                            Search chats...
                        </p>
                    </div>
                    <img
                        src={
                            theme === 'dark'
                                ? '/assets/navigation-icons/sidebar/text-icon-white.svg'
                                : '/assets/navigation-icons/sidebar/text-icon.svg'
                        }
                        className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px]"
                    />
                </div>
            </div>

            <div className="flex flex-col flex-grow pt-2 overflow-y-auto">
                <nav data-qa="navigation" className="flex-1 px-3 sm:px-4 pb-4">
                    <Navigation search={search} />
                </nav>
            </div>

            <div className="border-t px-3 py-3">
                {/* <div className='!rounded-lg bg-[#F5F5F5] dark:bg-black border border-[#e9eaeb] p-3 cursor-pointer hover:opacity-80 '>
          <div className='flex flex-row items-center mb-2'>
            <img
              src={theme === 'dark' ? '/assets/navigation-icons/sidebar/add-icon-white.svg' : '/assets/navigation-icons/sidebar/add-icon.svg'}
              className='object-contain w-6 h-6 sm:w-[20px] sm:h-[20px] mr-2'
            />
            <p className='font-semibold text-sm dark:text-primary-dark sm:text-base'>Add agent</p>
          </div>
          <p className='text-xs sm:text-sm dark:text-primary-dark'>Find more about our upcoming agents and deals.</p>
        </div> */}

                <div className="my-4 sm:my-5">
                    <ThemeToggle />
                </div>

                <img
                    src={
                        theme === 'dark'
                            ? '/assets/navigation-icons/sidebar/sidebar-icon-white.svg'
                            : '/assets/navigation-icons/sidebar/sidebar-icon.svg'
                    }
                    className="object-contain h-10 sm:h-[45px] my-2"
                />
            </div>
        </div>
    );
};

export default Sidebar;
